export default "__VITE_ASSET__BiilD8r5__"